export default "__VITE_ASSET__KvO6rbPt__"